export const PAYMENT_TABS = [
  { id: "overview", label: "Overview", icon: "📊" },
  { id: "farmer-payments", label: "Farmer Payments", icon: "🧑‍🌾" },
  { id: "client-payments", label: "Client Payments", icon: "🏪" },
  { id: "accounts", label: "Financial Accounts", icon: "💰" },
  { id: "cashbook", label: "Cashbook", icon: "📒" },
];
